"use strict";
import { createContext, memo, useContext, useEffect, useMemo } from "react";
import { sendAnalyticsEvent, analyticsConfig } from ".";
const DEFAULT_EVENT = "Page Viewed";
export const TraceContext = createContext({});
export function useTrace(trace) {
  const parentTrace = useContext(TraceContext);
  return useMemo(() => ({ ...parentTrace, ...trace }), [parentTrace, trace]);
}
export const Trace = memo(
  ({
    shouldLogImpression,
    name,
    children,
    page,
    section,
    modal,
    element,
    properties
  }) => {
    const parentTrace = useTrace();
    const combinedProps = useMemo(
      () => ({
        ...parentTrace,
        ...Object.fromEntries(Object.entries({ page, section, modal, element }).filter(([_, v]) => v !== void 0))
      }),
      [element, parentTrace, page, modal, section]
    );
    useEffect(() => {
      if (shouldLogImpression) {
        sendAnalyticsEvent(name ?? analyticsConfig?.defaultEventName ?? DEFAULT_EVENT, {
          ...combinedProps,
          ...properties,
          git_commit_hash: analyticsConfig?.commitHash
        });
      }
    }, [shouldLogImpression]);
    return <TraceContext.Provider value={combinedProps}>{children}</TraceContext.Provider>;
  }
);
Trace.displayName = "Trace";
